import React from 'react'
import { Routes, Route } from 'react-router-dom';

import Home from "./pages/Home";
import AmlPolicy from "./pages/AmlPolicies";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Pricing from "./pages/Pricing";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/aml-policy" element={<AmlPolicy />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
    </Routes>
  );
}

export default App;
